import { createAsyncThunk } from "@reduxjs/toolkit";
import { enqueueSnackbar } from "notistack";
import { RootState } from "../../../../store";
import { cloudChiprApi } from "../../../../../services/cloudchipr.api";
import { widgetDataNotFoundSelector } from "../../../selectors/widgets/common/widgetDataNotFoundSelector";
import { costBreakdownV2WidgetSetupDataPayloadSelector } from "../../../selectors/widgets/cost-breakdown-v2/setup/costBreakdownV2WidgetSetupDataPayloadSelector";

export const getCostBreakdownV2WidgetSetupDataThunk = createAsyncThunk(
  "dashboards/getCostBreakdownWidgetSetupData",
  async (_, { dispatch, getState }) => {
    const state = getState() as RootState;

    const { getUsersMeOrganisationsCurrentWidgetsCostBreakdown } =
      cloudChiprApi.endpoints;

    const widgetNotFound = widgetDataNotFoundSelector(
      state,
      "",
      "cost_breakdown",
    );

    const payload = costBreakdownV2WidgetSetupDataPayloadSelector(state);

    if (!payload) {
      return;
    }
    try {
      await dispatch(
        getUsersMeOrganisationsCurrentWidgetsCostBreakdown.initiate(payload, {
          forceRefetch: true,
        }),
      );
    } catch (e) {
      if (!widgetNotFound) {
        // @ts-expect-error todo: api fix
        const errMessage = e?.data?.message || "Something went wrong";
        enqueueSnackbar(errMessage, {
          variant: "snackbarAlert",
          AlertSnackBarProps: { severity: "error" },
        });
      }
    }
  },
);
